module.exports = "pegasus/assets/theme3/facebook-icon-1.png";